import React from 'react';
import { useSelector } from 'react-redux';
import { FaArrowRight, FaTools } from 'react-icons/fa';
import one from '../../assest/transport.png';
import two from '../../assest/transportone.png';
import three from '../../assest/transporttwo.png';
import './Project.css';
import Testimonial from '../../components/home/Testimonial';
import FaqSection from '../../components/about/FAQ';

const ProjectDetails = () => {
  const { language } = useSelector((state) => state.language);
  
  // Translation dictionary
  const translations = {
    gb: {
      // English
      heroTitle: 'Al Reem Residential Complex',
      heroButton: 'Get in Touch',
      aboutTitle: 'About Project',
      aboutText: 'Welcome to E-Commerce App, your premier destination for an exhilarating and unforgettable gambling experience. At Lucky Strike, we blend cutting-edge technology with the thrill of traditional casino games to bring you an unmatched gaming adventure right at your fingertips.',
      qualityTitle: 'Quality-Driven Approach to Building Projects',
      qualityText: 'Soluta ea platorem non, commodi beautech. Beatae ex re nos alia flexibus. Molestiae officiis ex magnis est harum quos beatae et nos earum nos ut ullam. Et similique fugiat ea intellis impedit et. Nostrum et platea nobis, soluta ex est odit. Et aut quia beatae beautech laudantium velit itaque. En optio nostrum est a class beate magnis est earum consequatur est.',
      stats: [
        { title: 'Location', value: 'New York' },
        { title: 'Value', value: 'From $500k' },
        { title: 'Status', value: '90% Complete' },
        { title: 'Duration', value: '12 Jan 2024' },
        { title: 'Project Type', value: 'GMP' },
      ]
    },
    sa: {
      // Arabic
      heroTitle: 'مجمع الريم السكني',
      heroButton: 'اتصل بنا',
      aboutTitle: 'حول المشروع',
      aboutText: 'مرحبًا بكم في تطبيق التجارة الإلكترونية، وجهتكم المفضلة لتجربة مقامرة مثيرة لا تُنسى. في لاكي سترايك، ندمج أحدث التقنيات مع إثارة ألعاب الكازينو التقليدية لتقديم مغامرة ألعاب لا مثيل لها بين يديك.',
      qualityTitle: 'نهج مدفوع بالجودة لمشاريع البناء',
      qualityText: 'سولوتا إيا بلاتوريم نون، كومودي بيوتيش. بيتاي إكس ري نوس أليا فليكسبوس. مولستيا أوفيسييس إكس ماجنيس إست هاروم كووس بيتاي إت نوس إاروم نوس أوت أولام. إت سيميلكيو فوجيات إيا إنتيليس إمبيديت إت. نوستروم إت بلاتيا نوبيس، سولوتا إكس إست أوديت. إت أوت كويا بيتاي بيوتيش لاودانتيوم فيليت إتاكوي. إن أوبتيو نوستروم إست أ كلاس بيتاي ماجنيس إست إاروم كونسيكواتور إست.',
      stats: [
        { title: 'الموقع', value: 'نيويورك' },
        { title: 'القيمة', value: 'من 500 ألف دولار' },
        { title: 'الحالة', value: '90% مكتمل' },
        { title: 'المدة', value: '12 يناير 2024' },
        { title: 'نوع المشروع', value: 'GMP' },
      ]
    },
    fr: {
      // French
      heroTitle: 'Complexe Résidentiel Al Reem',
      heroButton: 'Contactez-nous',
      aboutTitle: 'À propos du projet',
      aboutText: 'Bienvenue sur E-Commerce App, votre destination de premier choix pour une expérience de jeu passionnante et inoubliable. Chez Lucky Strike, nous combinons une technologie de pointe avec le frisson des jeux de casino traditionnels pour vous offrir une aventure de jeu incomparable au bout de vos doigts.',
      qualityTitle: 'Approche axée sur la qualité pour les projets de construction',
      qualityText: 'Soluta ea platorem non, commodi beautech. Beatae ex re nos alia flexibus. Molestiae officiis ex magnis est harum quos beatae et nos earum nos ut ullam. Et similique fugiat ea intellis impedit et. Nostrum et platea nobis, soluta ex est odit. Et aut quia beatae beautech laudantium velit itaque. En optio nostrum est a class beate magnis est earum consequatur est.',
      stats: [
        { title: 'Emplacement', value: 'New York' },
        { title: 'Valeur', value: 'À partir de 500k$' },
        { title: 'Statut', value: '90% Terminé' },
        { title: 'Durée', value: '12 Jan 2024' },
        { title: 'Type de projet', value: 'GMP' },
      ]
    },
    de: {
      // German
      heroTitle: 'Al Reem Wohnkomplex',
      heroButton: 'Kontakt aufnehmen',
      aboutTitle: 'Über das Projekt',
      aboutText: 'Willkommen bei E-Commerce App, Ihrem erstklassigen Ziel für ein aufregendes und unvergessliches Glücksspielerlebnis. Bei Lucky Strike kombinieren wir modernste Technologie mit dem Nervenkitzel traditioneller Casinospiele, um Ihnen ein unvergleichliches Spielabenteuer direkt auf Ihrem Gerät zu bieten.',
      qualityTitle: 'Qualitätsorientierter Ansatz für Bauprojekte',
      qualityText: 'Soluta ea platorem non, commodi beautech. Beatae ex re nos alia flexibus. Molestiae officiis ex magnis est harum quos beatae et nos earum nos ut ullam. Et similique fugiat ea intellis impedit et. Nostrum et platea nobis, soluta ex est odit. Et aut quia beatae beautech laudantium velit itaque. En optio nostrum est a class beate magnis est earum consequatur est.',
      stats: [
        { title: 'Standort', value: 'New York' },
        { title: 'Wert', value: 'Ab 500k$' },
        { title: 'Status', value: '90% Abgeschlossen' },
        { title: 'Dauer', value: '12. Jan 2024' },
        { title: 'Projekttyp', value: 'GMP' },
      ]
    }
  };

  // Get current translations based on language
  const t = translations[language] || translations.gb;

  const heroContent = {
    title: t.heroTitle,
    subtitle: '',
    description: '',
    buttonText: t.heroButton,
  };

  return (
    <>
      <section
        className="equipment-rental-hero"
        style={{
          background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)',
        }}
      >
        <div className="container h-100">
          <div className="row justify-content-center align-items-center text-center h-100">
            <div className="col-md-8">
              <h1 className="mb-3 mt-3">{heroContent.title}</h1>
              <h3 className="mb-4" style={{ color: '#EF4444' }}>
                {heroContent.subtitle}
              </h3>
              <p className="mb-4" style={{ color: '#000' }}>
                {heroContent.description}
              </p>
              <button
                className="btn btn-primary mt-3 mb-5"
                style={{
                  backgroundColor: '#B91C1C',
                  borderRadius: '50px',
                  color: 'white',
                  padding: '10px 30px',
                  border: '0',
                }}
              >
                {heroContent.buttonText}{' '}
                <FaArrowRight className="ms-2" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row">
            <h3>{t.aboutTitle}</h3>
            <p>{t.aboutText}</p>
          </div>
        </div>

        <div className="about-images container">
          <img src={one} alt="Highway" className="main-img" />
          <img src={two} alt="Truck 1" className="side-img" />
          <img src={three} alt="Truck 2" className="side-img" />
        </div>
      </section>

      <section>
        <div className="container start">
          <div className="project-overview">
            <h1 className="section-title">{t.qualityTitle}</h1>
            <p className="section-description">{t.qualityText}</p>

            <div className="stats-grid">
              {t.stats.map((stat, index) => (
                <div className="stat-card" key={index}>
                  <h4 className="stat-title">{stat.title}</h4>
                  <p className="stat-value">{stat.value}</p>
                </div>
              ))}
            </div>

            <p className="bottom-description">{t.qualityText}</p>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <Testimonial />
          <FaqSection />
        </div>
      </section>
    </>
  );
};

export default ProjectDetails;